"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20TransfersProcessor = void 0;
var SimpleProcessor_1 = require("../common/SimpleProcessor");
var Erc20TransferDocumentBuilder_1 = require("./Erc20TransferDocumentBuilder");
var Erc20TransfersProcessor = /** @class */ (function () {
    function Erc20TransfersProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.simpleProcessor = new SimpleProcessor_1.SimpleProcessor(this.collectionNameBuilder, Erc20TransferDocumentBuilder_1.Erc20TransferDocumentBuilder.build);
    }
    Erc20TransfersProcessor.prototype.process = function (batch) {
        return this.simpleProcessor.process(batch.erc20Transfers, batch);
    };
    return Erc20TransfersProcessor;
}());
exports.Erc20TransfersProcessor = Erc20TransfersProcessor;
//# sourceMappingURL=Erc20TransfersProcessor.js.map